import { AxiosInstance, default as axios } from 'axios'

import { API_BASE_URL } from '../envConfig'

let accessToken: string | null = null
let failedQueue: any = []

export const setAccessToken = (token: string | null) => {
  accessToken = token
  if (token) {
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`
  } else {
    delete client.defaults.headers.common['Authorization']
  }
}

const processQueue = (error: any) => {
  failedQueue.forEach((prom: any) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve()
    }
  })
  failedQueue = []
}

export const client = createAxiosClient({
  options: {
    baseURL: API_BASE_URL,
    timeout: 300000,
  },
})

function createAxiosClient({ options }: any): AxiosInstance {
  const client = axios.create(options)

  client.interceptors.response.use(
    (response) => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response
    },
    (error) => {
      const originalRequest = error.config
      // If error, process all the requests in the queue and logout the user.
      const handleError = (error: any) => {
        processQueue(error)
        // TODO: logout user?
        return Promise.reject(error)
      }

      /*
      // Refresh token conditions
      if (
        error.response?.status === 401 &&
        error.response.data.error === 'Token is not valid or has expired' &&
        originalRequest?._retry !== true
      ) {
        if (isRefreshing) {
          return new Promise(function (resolve, reject) {
            failedQueue.push({ resolve, reject })
          })
            .then(() => {
              return client(originalRequest)
            })
            .catch((err) => {
              return Promise.reject(err)
            })
        }
        isRefreshing = true
        originalRequest._retry = true

        LoginAPI.getAuthSession()
          .then((authSession) => {
            setJwtToken(authSession.tokens?.idToken?.toString() || '')
            processQueue(null)
            return client(originalRequest)
          }, handleError)
          .finally(() => {
            isRefreshing = false
          })
      }

      // Refresh token missing or expired => logout user...
      if (
        error.response?.status === 401 &&
        error.response.data.error === 'Token is not valid or has expired'
      ) {
        return handleError(error)
      }
      */

      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error)
    },
  )

  return client
}
